import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  // root: {
  //   overflowY: "auto",
  // },
  // tableWrapper: {
  //   paddingBlock: 12,
  // },
  // tableHeader: {
  //   display: "flex",
  //   justifyContent: "space-between",
  //   alignItems: "center",
  //   flexWrap: "wrap",
  //   rowGap: 8,
  //   "& .MuiTypography-root": {
  //     fontWeight: 500,
  //   },
  //   "& .MuiButton-root": {
  //     color: "gray",
  //     textTransform: "capitalize",
  //     border: "1px solid #c5baba",
  //     "&:hover": {
  //       border: "1px solid #848181",
  //       backgroundColor: "#fff",
  //     },
  //   },
  // },
  // dataGridTable: {
  //   paddingBlock: 20,
  //   "& .MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
  //     outline: "none !important",
  //   },
  //   "& .MuiDataGrid-columnHeaders": {
  //     background: "#1D426D33",
  //   },
  //   "& .MuiDataGrid-columnHeaderTitle": {
  //     fontWeight: 700,
  //     textTransform: "uppercase",
  //     fontSize: 14,
  //   },
  //   "& .MuiDataGrid-iconSeparator ": {
  //     display: "none",
  //   },
  //   "& .MuiDataGrid-virtualScroller": {
  //     scrollbarWidth: "thin",
  //     "&::-webkit-scrollbar": {
  //       height: 6,
  //     },
  //   },
  //   "& .MuiDataGrid-footerContainer": {
  //     justifyContent: "flex-start",
  //   },
  //   "& .MuiTablePagination-selectLabel": {
  //     fontSize: 13,
  //   },
  //   "& .MuiTablePagination-displayedRows": {
  //     fontSize: 13,
  //   },
  //   "& .MuiTablePagination-select": {
  //     fontSize: 13,
  //   },
  // },
  // lightText: {
  //   "& .MuiTypography-root": {
  //     color: "rgba(0, 0, 0, 0.7)",
  //   },
  // },
  // linkText: {
  //   "& .MuiTypography-root": {
  //     color: "#0f5fff",
  //     cursor: "pointer",
  //   },
  // },
  // spacing: {
  //   paddingBlockStart: 4,
  // },
  // iconsWrapper: {
  //   display: "flex",
  //   gap: 8,
  // },
  // deleteIcon: {
  //   border: "1px solid #f10707",
  //   display: "flex",
  //   justifyContent: "center",
  //   borderRadius: 5,
  //   padding: 2,
  //   alignItems: "center",
  //   "& .MuiSvgIcon-root": {
  //     color: "#f10707",
  //     cursor: "pointer",
  //     fontSize: 20,
  //   },
  // },
  // editIcon: {
  //   border: `1px solid #11823b`,
  //   display: "flex",
  //   justifyContent: "center",
  //   borderRadius: 5,
  //   padding: 2,
  //   alignItems: "center",
  //   background: "#11823b",
  //   "& .MuiSvgIcon-root": {
  //     color: "#ffffff",
  //     cursor: "pointer",
  //     fontSize: 20,
  //   },
  // },
  // addBtn: {
  //   display: "flex",
  //   justifyContent: "flex-end",
  //   padding: "10px 20px",
  // },
}));

export default useStyles;
